import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CartridgesOverviewComponent } from './cartridges-overview/cartridges-overview.component';
import { VariantsOverviewBreadcrumbResolver } from '@markant-platform/cartridges-backoffice/feature-variants-overview';
import { CartridgeMembersOverviewComponent } from '@markant-platform/shared/cartridge/feature-cartridge-members-overview';

const routes: Routes = [
  {
    path: '',
    component: CartridgesOverviewComponent,
  },
  {
    path: ':cartridgeId/members',
    resolve: {
      subBreadcrumbs: VariantsOverviewBreadcrumbResolver,
    },
    component: CartridgeMembersOverviewComponent,
  },
  {
    path: 'management',
    loadChildren: () =>
      import('@markant-platform/cartridge/feature-management-view').then(m => m.CartridgeFeatureManagementViewModule),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  declarations: [],
  exports: [RouterModule],
})
export class BackofficeFeatureCartridgesOverviewModuleRoutingModule {}
